import React from 'react';
interface DataField {
  label: string;
  value: string;
}

interface SuccessModalProps {
  isOpen: boolean;
  title?: string;
  dataFields: DataField[];
  actions: string[];
  onClose: () => void;
  onPrimaryAction?: () => void;
  onSecondaryAction: () => void;
  primaryButtonText?: string;
  secondaryButtonText?: string;
  hidePrimaryButton?: boolean;
  actionsHeader?: string;
}

const SuccessModal: React.FC<SuccessModalProps> = ({
  isOpen,
  title = 'Success!',
  dataFields,
  actionsHeader,
  actions,
  onClose,
  onPrimaryAction,
  onSecondaryAction,
  primaryButtonText = 'Create Another',
  secondaryButtonText = 'View List',
  hidePrimaryButton = false,
}) => {
  if (!isOpen) return null;

  return (
    <div
      className="fixed left-[255px] top-[72px] right-0 bottom-0 z-40 flex items-center justify-center"
      style={{
        background:
          'linear-gradient(174.07deg, rgba(173, 12, 98, 0.85) 0.38%, rgba(98, 28, 67, 0.85) 95.87%)',
      }}
    >
      <div className="bg-[#621C43] max-w-xl w-full rounded-xl text-white relative shadow-xl border border-[#7a2757] min-h-[24rem]">
        {/* Close button */}
        <button
          onClick={onClose}
          className="absolute top-2 right-4 text-white hover:text-gray-300 text-xl font-bold"
          aria-label="Close popup"
        >
          &times;
        </button>

        {/* Header */}
        <div className="border-b p-4 border-[#FFF8ED]">
          <h2 className="text-lg font-semibold text-center">{title}</h2>
        </div>

        {/* Details - Dynamic Key-Value Pairs */}
        <div className="text-center mb-5 leading-relaxed text-md mt-5">
          {dataFields.map((field, index) => (
            <p key={index}>
              <strong>{field.label}:</strong> {field.value}
            </p>
          ))}
        </div>

        {/* Post-Creation Actions */}

        <div className="mx-4 my-10">
          <p className="text-sm my-2">{actionsHeader}</p>
          <div className="rounded-md bg-[#A15C86]/30 pt-2 flex gap-3 text-xs text-[#EEE] font-medium">
            {actions.map((action, i) => (
              <div key={i} className="flex-1 flex items-center gap-2 rounded px-4 py-2">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-3.5 w-3.5 text-green-400"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  strokeWidth={2}
                >
                  <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
                </svg>
                {action}
              </div>
            ))}
          </div>
        </div>

        {/* Buttons */}
        <div className="flex justify-between  py-5 px-6 flex-col sm:flex-row border-t border-black">
          {/* Primary Button - Only show when allowed */}
          {!hidePrimaryButton && onPrimaryAction && (
            <button
              onClick={onPrimaryAction}
              className="bg-[#0CA96F] flex-1 hover:bg-[#0b9e68] text-white py-2 mr-2 rounded-md text-sm"
            >
              {primaryButtonText}
            </button>
          )}
          <button
            onClick={onSecondaryAction}
            className="flex-1 bg-[#4C86E7] hover:bg-[#4679d1] rounded-md py-2 text-sm"
          >
            {secondaryButtonText}
          </button>
        </div>
      </div>
    </div>
  );
};

export default SuccessModal;
